import React, { useEffect, useState } from 'react';

/**
 * High5AsicsIndirim: ASICS indirim dönemi (15–19 Eki 2026) öncesi / indirim / sonrası analizi.
 * Route: /r/high5-asics-indirim (sidebar YOK, tam ekran slayt, 17 slayt 16:9, Türkçe).
 * Yeniden üretmek için: node src/pages/high5-asics-indirim/build.js (veri: fetch_ga4.js, fetch_items.js, data.py) (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ~135KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function High5AsicsIndirim() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./high5AsicsIndirimHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="High5 · ASICS İndirim Dönemi"
      srcDoc={html}
      style={fill}
    />
  );
}
